import DocApi from "apis/docApi";
import { ActionTypes } from "store/actionTypes";
import { AppDispatch } from "store";

const api = new DocApi();

export const getDocs =
  (customerId?: string) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.DOC_LOADING });
    try {
      const response = await api.getDocs(customerId);
      dispatch({ type: ActionTypes.GET_DOCS, payload: response });
    } catch (error: any) {
      dispatch({ type: ActionTypes.DOC_ERROR, payload: error.message });
    }
  };

export const getDocById =
  (id: string | number) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.DOC_LOADING });
    try {
      const response = await api.getDocById(id);
      dispatch({ type: ActionTypes.GET_DOC_BY_ID, payload: response });
    } catch (error: any) {
      dispatch({ type: ActionTypes.DOC_ERROR, payload: error.message });
    }
  };

export const addDoc = (doc: any) => async (dispatch: AppDispatch) => {
  dispatch({ type: ActionTypes.DOC_LOADING });
  try {
    const response = await api.addDoc(doc);
    dispatch({ type: ActionTypes.ADD_DOC, payload: response });
  } catch (error: any) {
    dispatch({ type: ActionTypes.DOC_ERROR, payload: error.message });
  }
};

export const updateDoc = (doc: any) => async (dispatch: AppDispatch) => {
  dispatch({ type: ActionTypes.DOC_LOADING });
  try {
    const response = await api.updateDoc(doc);
    dispatch({
      type: ActionTypes.UPDATE_DOC,
      payload: { ...doc, ...response },
    });
  } catch (error: any) {
    dispatch({ type: ActionTypes.DOC_ERROR, payload: error.message });
  }
};

export const deleteDoc =
  (id: string | number) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.DOC_LOADING });
    try {
      await api.deleteDoc(id);
      dispatch({ type: ActionTypes.DELETE_DOC, payload: id });
    } catch (error: any) {
      dispatch({ type: ActionTypes.DOC_ERROR, payload: error.message });
    }
  };

export const setDocCustomerSelection = (customerId: string | null) => {
  return { type: ActionTypes.SET_DOC_CUSTOMER_SELECTION, payload: customerId };
};

